import {useQuery} from '@tanstack/react-query'

import useRequestParams from 'src/feature/bite/hook/request'
import {StatementListSchemaResponse} from '../domain'
import {useStatement} from '../hook'
import {API} from 'src/feature/bite/domain'

const sampleData = {
  response: {
    transactions: [
      {
        paymentType: 'Cash',
        totalSales: 1000.0,
        numberOfTransactions: 100,
        transactionPercentage: '0.10%',
        feePerTransaction: 0.01,
        totalDue: 2,
      },
      {
        paymentType: 'Debit/Credit Card',
        totalSales: 1000.0,
        numberOfTransactions: 100,
        transactionPercentage: '2.50%',
        feePerTransaction: 0.0,
        totalDue: 25.0,
      },
      {
        paymentType: 'Flex Card',
        totalSales: 1000.0,
        numberOfTransactions: 100,
        transactionPercentage: '1.50%',
        feePerTransaction: 0.05,
        totalDue: 20.0,
      },
      {
        paymentType: 'Points Redemption',
        totalSales: 100.0,
        numberOfTransactions: 10,
        transactionPercentage: '2.50%',
        feePerTransaction: 0.0,
        totalDue: 2.5,
      },
      {
        paymentType: 'Own Coupon Redemption',
        totalSales: 100.0,
        numberOfTransactions: 20,
        transactionPercentage: '2.50%',
        feePerTransaction: 0.0,
        totalDue: 2.5,
      },
      {
        paymentType: '3rd Coupon Redemption',
        totalSales: 100.0,
        numberOfTransactions: 20,
        transactionPercentage: '2.50%',
        feePerTransaction: 0.0,
        totalDue: 2.5,
      },
      {
        paymentType: 'Sales Fee Total',
        totalSales: 3300.0,
        numberOfTransactions: 350.0,
        totalDue: 54.5,
      },
      {
        paymentType: 'Monthly Loyalty Mngmt. Fee',
        feePerTransaction: 20.0,
        totalDue: 20.0,
      },
      {
        paymentType: 'Total Due',
        totalDue: 74.5,
      },
    ],
    periods: [
      {value: '1', label: 'October 2023'},
      {value: '2', label: 'September 2023'},
      {value: '3', label: 'Last 3 Months'},
      {value: '4', label: 'Last 6 Months'},
      {value: '5', label: 'This Year'},
      {value: '6', label: 'Last 1 Year'},
      {value: '7', label: 'Last 2 Year'},
    ],
    activePeriod: '1',
  },
  responseResult: {
    result: true,
    exceptionDetail: null,
    code: 1,
  },
}

export function useGetStatement() {
  const {auth, headers} = useRequestParams()
  const {listSet, listFilter, listFilterSet} = useStatement()

  return useQuery(
    ['statement', listFilter],
    async () => {
      const response = await fetch(`${API}/Statement/Detail`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          ...listFilter,
          userID: auth().id,
        }),
      })

      const data = await response.json()

      const safeParse = StatementListSchemaResponse.safeParse(data)

      if (!safeParse.success) {
        throw new Error(safeParse.error.message)
      }

      const parse = StatementListSchemaResponse.parse(data)

      listSet(parse.response)
      listFilterSet({
        ...listFilter,
      })

      return true
    },
    {
      enabled: true,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
      retry: false,
      cacheTime: 0,
      staleTime: 0,
      onSuccess: () => {},
      onError: (error) => {
        console.log(error)
      },
    }
  )
}
